//splide
const slideRanking = document.getElementById('slideRanking');
let splideRanking = new Splide(slideRanking, {
  type: 'slide',
  perPage: 4,
  perMove: 1,
  speed: 500,
  gap: '24px',
  pagination: false,
  arrows: true,
  breakpoints: {
    840: {
      perPage: 2,
      perMove: 2,
      focus: 0,
    },
  },
});

splideRanking.mount();

//cource change
const switchs = document.querySelectorAll('.cm-ranking__switchs button');
if (switchs.length > 0) {
  switchs.forEach((el) => {
    el.addEventListener('click', (e) => {
      switchs.forEach((el) => {
        el.classList.remove('is-active');
      });

      const target = e.target.dataset.handle;
      e.target.classList.add('is-active');

      // ローディング
      const slideRanking = document.querySelector('.slideRanking');
      const slideRankingWrap = slideRanking.querySelector('.splide__track');
      const loadingParentDiv = document.createElement('div');
      loadingParentDiv.className = 'splide__track';
      const loadingChildDiv = document.createElement('div');
      loadingChildDiv.style.textAlign = 'center';
      loadingChildDiv.className = 'slideRanking__loading';
      loadingChildDiv.textContent = '読み込み中';
      loadingParentDiv.appendChild(loadingChildDiv);
      slideRanking.replaceChild(loadingParentDiv, slideRankingWrap);

      const url = location.origin + '/collections/' + target + '?view=ajax-ranking';

      //絞り込み先のURLから内容を取得して、非同期で更新
      const checkPage = async () => {
        try {
          //絞り込み先の内容を取得
          const response = await fetch(url);
          const data = await response.text();
          let parser = new DOMParser();
          let doc = parser.parseFromString(data, 'text/html');
          let goRankingWrap = doc.querySelector('.splide__track');

          //現サイトの要素
          const slideRanking = document.querySelector('.slideRanking');
          const slideRankingWrap = slideRanking.querySelector('.splide__track');

          //旧 Splide を破棄
          splideRanking.destroy();

          //絞り込み先の内容を設定。絞り込み先がなければ、実績なしの表示
          if (goRankingWrap == null) {
            // 実績なし要素の作成
            const parentDiv = document.createElement('div');
            parentDiv.className = 'splide__track';
            const childDiv = document.createElement('div');
            childDiv.style.color = '#666666';
            childDiv.style.textAlign = 'center';
            childDiv.textContent = '表示可能な商品はありません。';
            parentDiv.appendChild(childDiv);
            slideRanking.replaceChild(parentDiv, slideRankingWrap);
          } else {
            slideRanking.replaceChild(goRankingWrap, slideRankingWrap);
            splideRanking.mount();
            ReloadSmartWishlist();
          }
        } catch (error) {
          if (error.name === 'AbortError') {
            console.log('Fetch aborted.');
          } else {
            console.error('Error:', error);
          }
        }
      };
      checkPage();
    });
  });
}
